export function propertyRoute(id: string): string {
  if (id === 'belvedere') return '/the-belvedere';
  if (id === 'hannahs-pearl') return '/hannahs-pearl';
  if (id === 'beach-beach-baby') return '/beach-beach-baby';
  if (id === 'bella-vita') return '/bella-vita';
  if (id === 'sunset-bungalow-30a') return '/sunset-bungalow-30a';
  return '/sea-dreams';
}
